import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display"]

  connect() {
    this.value = "0"
    this.updateDisplay()
    console.log("Cash numpad controller connected")
  }

  // Handle numpad button press
  press(event) {
    const key = event.currentTarget.dataset.key
    
    if (this.value === "0") {
      this.value = key
    } else {
      // Prevent the value from becoming too large
      if (this.value.length < 10) {
        this.value += key
      }
    }
    
    this.updateDisplay()
  }
  
  // Clear the display
  clear() {
    this.value = "0"
    this.updateDisplay()
  }
  
  // Handle quick amount buttons
  quickAmount(event) {
    const amount = parseInt(event.currentTarget.dataset.amount)
    const isFullAmount = event.currentTarget.dataset.fullAmount === "true"

    if (isFullAmount) {
      // 전체금액 버튼은 합산하지 않고 정확한 금액으로 설정
      this.value = amount.toString()
    } else {
      // 다른 금액 버튼은 기존 값에 선택된 금액을 더합니다 (누산)
      const currentAmount = parseInt(this.value) || 0
      const newAmount = currentAmount + amount
      this.value = newAmount.toString()
    }

    this.updateDisplay()
  }
  
  // Update the display with formatted number
  updateDisplay() {
    try {
      // Parse value as integer and format with locale separator
      const formattedValue = parseInt(this.value).toLocaleString()
      this.displayTarget.textContent = formattedValue
    } catch (e) {
      console.error("Error updating display:", e)
      this.displayTarget.textContent = "0"
      this.value = "0"
    }
  }
  
  // Handle confirm button
  async confirm(event) {
    const isBankTransfer = event.params.bankTransfer === true
    const amount = parseInt(this.value)

    const posEl = document.querySelector('[data-controller~="pos"]')
    const posController = posEl && this.application.getControllerForElementAndIdentifier(posEl, 'pos')

    if (posController) {
      try {
        await posController.cartAction("cart_set_cash", {
          amount:           amount,
          is_bank_transfer: isBankTransfer
        })
      } catch (e) {
        console.error("cart_set_cash failed:", e)
        alert("서버 통신 오류입니다. 다시 시도해주세요.")
        return
      }
    }

    // 모달 닫기
    const modalsFrame = document.querySelector('turbo-frame[id="modals"]')
    if (modalsFrame) modalsFrame.innerHTML = ""
  }
}
